function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  role: "img",
  "aria-hidden": "true"
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: "10",
  cy: "10",
  r: "9.524",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M16.087 8.692a1.73 1.73 0 00-1.13.48 8.4 8.4 0 00-4.548-1.454l.765-3.685 2.528.53a1.183 1.183 0 10.156-.72l-2.896-.58a.366.366 0 00-.437.28v.006l-.872 4.1A8.46 8.46 0 005.048 9.1a1.724 1.724 0 00-2.36 2.513 1.672 1.672 0 00.464.31 3.845 3.845 0 000 .52c0 2.646 3.083 4.8 6.885 4.8s6.885-2.148 6.885-4.8a3.845 3.845 0 000-.52 1.7 1.7 0 00-.834-3.23zm-10.068 2.9a1.237 1.237 0 111.236 1.237 1.237 1.237 0 01-1.237-1.242zm6.925 3.354a5.408 5.408 0 01-2.916.93 5.612 5.612 0 01-2.912-.9.375.375 0 11.4-.633 4.86 4.86 0 002.51.782 4.67 4.67 0 002.505-.807.375.375 0 11.41.627zm-.224-2.117a1.237 1.237 0 111.238-1.238 1.237 1.237 0 01-1.236 1.234z"
}));